export default __webpack_public_path__ + "static/media/decision.d9a54b32.svg";